module.exports = __webpack_public_path__ + "static/media/Football.7b275018.svg";